import { z } from 'zod'

import { SlaConfiguration } from './AreaPriorities'

export const SlaMetrics = z.object({
  slaConfiguration: SlaConfiguration,
  slaConfigurationTime: z.string().nullable(),
  time: z.string().nullable()
})

export type SlaMetrics = z.infer<typeof SlaMetrics>
